import React from 'react'
import SelectedDepartmentFilter from 'support/filters/SelectedDepartmentFilter'
import ResourceFilter from 'support/filters/ResourceFilter'
import { Translation } from '@morningtrain/react-translations'

export default function UserFilter ({ name = 'user_id', operationName = 'select', children = null }) {
  return (
    <ResourceFilter
      name={name}
      resourceName="users.users"
      operationName={operationName}
      optionsKey="name"
      label={<Translation name="filters.user.label"/>}
      placeholder="-"
    >
      <SelectedDepartmentFilter/>
      {children}
    </ResourceFilter>
  )
}
